<template>
  <div>
    <el-dialog
      title="区域巡检结束"
      append-to-body
                :fullscreen="dialogFull"
                :close-on-click-modal="false"
                :destroy-on-close="true"
                top="30px"
                :before-close="handleClose"
                :visible.sync="dialogShow"
                width="50%"
      :modal-append-to-body="false"
    >
    <template slot="title">
            <div class="avue-crud__dialog__header">
                    <span class="el-dialog__title">
                            区域巡检结束
                    </span>
                    <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFull=!dialogFull"></i>
                    
            </div>
            <el-divider></el-divider>
    </template>
      <avue-form
        :option="option"
        v-model="form"
        v-if="dialogShow"
        @submit="formSubmit"
        @error="formError"
      >
        <template slot="areaId">
          <el-select
            v-model="form.areaId"
            placeholder="请选择需求区域"
            ref="addConnectSelect"
          >
            <el-option
              :value="form.areaId"
              show-all-levels
              :label="form.areaName"
            >
              <el-tree
                node-key="id"
                :data="treeFormAreaData"
                :props="treeProps"
                :load="editAreaLazyLoadTree"
                lazy
                @node-click="editAreaNodeTreeClick_"
              >
              </el-tree>
            </el-option>
          </el-select>
        </template>
        <template slot="remark">
          <div>
            <el-input
              type="textarea"
              :rows="3"
              maxlength="500"
              show-word-limit
              placeholder="请输入内容"
              v-model="form.remark"
            >
            </el-input>
            <remarkModel
              :remark.sync="form.remark"
              ref="remarkModel"
            ></remarkModel>
          </div>
        </template>
        <template slot="attachList">
          <div>
            <vupload :fileList.sync="form.attachList"></vupload>
          </div>
        </template>
        <template slot="workTime">
           <a-time :time="form.workTime" @update="serviceTime"></a-time>
          <!-- <el-input
            maxlength="10"
            @input="workTimeInput"
            :value="form.workTime"
          >
            <template slot="append">小时</template> -->
          <!-- </el-input> -->
        </template>
        <template slot="menuForm">
          <el-button @click="handleClose"
            ><span class="el-icon-close"></span> 取消</el-button
          >
        </template>
      </avue-form>
    </el-dialog>
  </div>
</template>
<script>
import { endOption, omitNumber } from "./option.js";
import {
  getGroupDetails,
  getCooperateList,
  setCooperate,
  confirm,
  getRemarkList,
  start,
  finish,
  lazyAreaTree,
} from "@/api/gateservice/order/order-list/order-list";
import remarkModel from "../components/remark-model";
import vupload from "@/views/components/v-upload";
import aTime from "../components/aTime.vue"; 
export default {
  components: {
    remarkModel,
    vupload,
    aTime
  },
  data() {
    return {
      form: {
        orderId: "",
        attachList: [],
        areaId: "",
      },
      treeFormAreaData: [], //懒加载区域树 --报修表单中
      treeProps: {
        //报修表单 --需求区域树的配置
        //标题
        label: "name",
        //值
        value: "id",
        //子节点
        children: "zones",
        //是否叶子节点
        isLeaf: "hasChildren",
        //本节点类型key值
        objectType: "id",
        //本节点类型名
        objectTypeName: "name",
      },
      data: {},
      cheackedPeople: [],
      userList: [],
      dialogShow: false,
      option: endOption,
    };
  },
  created() {},
  methods: {
    // 弹窗关闭前
        handleClose(done){
                let self = this;
                this.$confirm('确认关闭?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                })
                .then(()=> {
                        
                        self.dialogShow = false;
                        
                })
                .catch(()=> {
                        
                });
        },
     serviceTime(date){
            //服务完成时间
            this.form.workTime =Number(date.hour)*60 + Number(date.minutes);
        },
    workTimeInput(e) {
      this.form.workTime = omitNumber(e);
    },
    openDialog(data) {
      this.dialogShow = true;
      console.log("openDialog");
      this.form = {
        orderId: data.orderId,
        attachList: [],
        areaName: "",
        areaId: "",
      };
      console.log(this.$refs.remarkModel);
      getRemarkList({
        orderId: data.orderId,
        actionType: data.actionType,
      }).then((res) => {
        this.$refs.remarkModel.setRemarkList(res.data);
      });
      this.getCooperateList(data.orderId);
    },
    closeDialog() {
      this.dialogShow = false;
    },
    // 获取协同人列表
    getCooperateList(orderId) {
      this.form.orderId = orderId;
      getGroupDetails({ orderId: orderId }).then((res) => {
        console.log(res);
        res.data.userList.forEach((ele) => {
          ele.namePhone = ele.realName + " (" + ele.phone + ")";
        });
        const column = this.findObject(this.option.column, "cooperateLists");
        column.dicData = res.data.userList;
        this.userList = res.data.userList;
      });
      getCooperateList({ orderId: orderId }).then((res) => {
        let temArr = [];
        res.data.forEach((ele) => {
          temArr.push(ele.userId);
        });
        this.form.cooperateLists = temArr;
        this.cheackedPeople = res.data;
        console.log(res);
      });
    },
    formError(done) {
      done();
    },
    formSubmit(form, done) {
      finish(form)
        .then((res) => {
          if (res.msg == "操作成功") {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.dialogVisible = false;
            this.dialogShow = false;
          } else {
            this.$message.error(res.msg);
          }
          this.$emit("handleClose", function () {
            console.log("关闭历程表");
          });

          this.dialogShow = false;
          done();
        })
        .catch((err) => {
          done();
        });
    },
    // 报修表单  -- 服务地点切换
    editAreaNodeTreeClick_(node) {
      setTimeout(() => {
        let nodeId = node.id;
        let nodeTitle = node.name;
        // this.form.areaName = nodeTitle;
        // this.form.areaId = nodeId;

        this.form = Object.assign({}, this.form, {
          areaName: nodeTitle,
          areaId: nodeId,
        });
        this.$refs.addConnectSelect.blur();
      }, 0);
    },
    // 报修表单  --服务地点数据
    editAreaLazyLoadTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
      } else {
        id = node.data.id;
      }
      lazyAreaTree({ parentId: id, projectId: this.data.projectId }).then(
        ({ data }) => {
          if (data instanceof Array) {
            data.forEach((item) => {
              item.hasChildren = !item.hasChildren;
            });
          }
          resolve(data);
        }
      );
    },
  },
};
</script>
